/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import {
  questionTypeIconMap,
  DefaultQuestionIcon,
} from 'src/components/ts-components/QuestionTypeIcons'
import { typeDisplayLabels, QuestionType } from './typeDisplayLabels'

/**
 * Generate question type options with icons for select inputs.
 * Each option includes the appropriate icon from questionTypeIconMap
 * alongside the display label, matching the visual style used in question lists.
 */
export const typeOptions: { label: React.ReactNode; value: QuestionType }[] = (
  Object.keys(typeDisplayLabels) as QuestionType[]
).map((questionType) => {
  const IconComponent = questionTypeIconMap[questionType] || DefaultQuestionIcon
  const displayLabel = typeDisplayLabels[questionType]

  return {
    label: (
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 8px;
        `}
      >
        <IconComponent size={16} color={colors.NEUTRAL_50} />
        <span>{displayLabel}</span>
      </div>
    ),
    value: questionType,
  }
})
